export default {"src":"/_next/static/media/0x924828a9fb17d47d0eb64b57271d10706699ff11.93805349.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};